module.exports = __webpack_public_path__ + "media/images/index-hero-fairy-f68c9ee2ba977e48b4bf8ef456fad3ab.svg";